import React, { memo, useEffect, useState } from "react";
import { Modal } from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import { useGetState } from "ahooks";
import { reqGetOrderInvoice, reqPostOrderInvoice } from "../../../../api";
const OrderNoteModal = memo(
  ({
    data,
    callColse,
    toastFun
  }) => {
    const [invoicesData, setInvoicesData] = useState({}); //开票数据
    const [invoicesLoading, setInvoicesLoading] = useState(false); //获取开票数据加载状态
    const [invoicesForm, setInvoicesForm, getInvoicesForm] = useGetState({
      companyName: "",
      companyNumber: "",
      companyAddress: "",
      inputNameTip: false,
      inputNumberTip: false,
      inputAddressTip: false,
    }); //开票表格填写数据

    const handleInvoices = async (id) => {
      setInvoicesLoading(true);
      try {
        let res = await reqGetOrderInvoice({ order_id: id });
        if (res.code === "200") {
          setInvoicesForm((prevValue) => ({
            ...prevValue,
            companyName: res.data.company_name,
            companyNumber: res.data.company_no,
            companyAddress: res.data.address,
            inputNameTip: false,
            inputNumberTip: false,
            inputAddressTip: false,
          }));
          setInvoicesData(res.data);
          setInvoicesLoading(false);
        } 
          
      } catch (error) {
        
      }
    };

    // 输入设置
        const onInvoices = (e, type) => {
          let text = e.target.value;
          switch (type) {
            case "name":
              setInvoicesForm((prevValue) => ({
                ...prevValue,
                companyName: text,
              }));
              if (text === "") {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputNameTip: true,
                }));
              } else {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputNameTip: false,
                }));
              }
              break;
            case "number":
              setInvoicesForm((prevValue) => ({
                ...prevValue,
                companyNumber: text,
              }));
              if (text === "") {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputNumberTip: true,
                }));
              } else {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputNumberTip: false,
                }));
              }
              break;
            case "address":
              setInvoicesForm((prevValue) => ({
                ...prevValue,
                companyAddress: text,
              }));
              if (text === "") {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputAddressTip: true,
                }));
              } else {
                setInvoicesForm((prevValue) => ({
                  ...prevValue,
                  inputAddressTip: false,
                }));
              }
              break;
            default:
              break;
          }
        };
        const onInvoicesSubmit = async () => {
            try {
                
            
          let params = {
            company_name: getInvoicesForm().companyName,
            company_no: invoicesForm.companyNumber,
            address: invoicesForm.companyAddress,
            order_id: invoicesData.dsm_order_id,
          };
          if (
            invoicesForm.companyName === undefined &&
            invoicesForm.companyNumber === undefined &&
            invoicesForm.companyAddress === undefined
          ) {
            setInvoicesForm((prevValue) => ({
              ...prevValue,
              inputNameTip: true,
              inputNumberTip: true,
              inputAddressTip: true,
            }));
    
            return;
          }
          if (
            invoicesForm.companyName === "" ||
            invoicesForm.companyName === undefined
          ) {
            setInvoicesForm((prevValue) => ({
              ...prevValue,
              inputNameTip: true,
            }));
            return;
          }
          if (
            invoicesForm.companyNumber === "" ||
            invoicesForm.companyNumber === undefined
          ) {
            setInvoicesForm((prevValue) => ({
              ...prevValue,
              inputNumberTip: true,
            }));
            return;
          }
          if (
            invoicesForm.companyAddress === "" ||
            invoicesForm.companyAddress === undefined
          ) {
            setInvoicesForm((prevValue) => ({
              ...prevValue,
              inputAddressTip: true,
            }));
            return;
          }
          
            let res = await reqPostOrderInvoice(params);
            if (res.code === "200") {
              window.open(res.data.pdf_url);
              toastFun("Download successfully", false);
          }
        } catch (error) {
                
        }
        };
        useEffect(() => {
            let isMount = false;
            if (!isMount && data.open) {
                handleInvoices(data.id);
            }
            return () => {
                isMount = true;
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [data]);
    return (
      <div>
        <Modal
          size="large"
          open={data.open}
          onClose={()=>callColse()}
          title={intl.get("Invoices")}
          primaryAction={{
            content: intl.get("Download"),
            onAction: onInvoicesSubmit,
            disabled: invoicesLoading,
          }}
          secondaryActions={[
            {
              content: intl.get("Close"),
              onAction: ()=>callColse(),
              disabled: invoicesLoading,
            },
          ]}
          loading={invoicesLoading}
        >
          <div className="invoices_modal">
            <div className="invoices_modal_title">
              <img src="/dropshipman-logo.png" alt="dropshipman"></img>
              {intl.get("Dropshipman Limited")}{" "}
            </div>
            <div className="invoices_modal_box">
              <div className="invoices_modal_top">
                <div className="invoices_modal_number">
                {intl.get("INVOICE Number")}: {invoicesData.invoice_no}
                </div>
                <div className="invoices_modal_date">
                {intl.get("REVISED DATE")}: {invoicesData.revised_date}
                </div>
              </div>
              <div className="invoices_modal_mid">
                <div style={{ position: "relative" }}>
                  <span>{intl.get("Company Name")}: </span>
                  <input
                    maxLength={100}
                    style={{
                      borderColor: invoicesForm.inputNameTip
                        ? "#f00"
                        : "rgba(190, 187, 187,.8)",
                    }}
                    value={invoicesForm.companyName}
                    disabled={invoicesData.id ? true : false}
                    onChange={(e) => onInvoices(e, "name")}
                  />
                  {invoicesForm.inputNameTip && (
                    <p
                      style={{
                        position: "absolute",
                        left: "20%",
                        bottom: "-5px",
                        color: "#f00",
                      }}
                    >
                      {intl.get("Please fill in the required fields.")}
                    </p>
                  )}
                </div>
                <div style={{ position: "relative" }}>
                  <span>{intl.get("Company Number")}:</span>{" "}
                  <input
                    maxLength={100}
                    style={{
                      borderColor: invoicesForm.inputNumberTip
                        ? "#f00"
                        : "rgba(190, 187, 187,.8)",
                    }}
                    value={invoicesForm.companyNumber}
                    disabled={invoicesData.id ? true : false}
                    onChange={(e) => onInvoices(e, "number")}
                  />
                  {invoicesForm.inputNumberTip && (
                    <p
                      style={{
                        position: "absolute",
                        left: "20%",
                        bottom: "-5px",
                        color: "#f00",
                      }}
                    >
                      {intl.get("Please fill in the required fields.")}
                    </p>
                  )}
                </div>
                <div style={{ position: "relative" }}>
                  <span>{intl.get("Address")}:</span>{" "}
                  <input
                    maxLength={200}
                    style={{
                      borderColor: invoicesForm.inputAddressTip
                        ? "#f00"
                        : "rgba(190, 187, 187,.8)",
                    }}
                    value={invoicesForm.companyAddress}
                    disabled={invoicesData.id ? true : false}
                    onChange={(e) => onInvoices(e, "address")}
                  />
                  {invoicesForm.inputAddressTip && (
                    <p
                      style={{
                        position: "absolute",
                        left: "20%",
                        bottom: "-5px",
                        color: "#f00",
                      }}
                    >
                      {intl.get("Please fill in the required fields.")}
                    </p>
                  )}
                </div>
              </div>
              <div className="invoices_modal_bottom">
                <div>
                  <div>{intl.get("Name of Commodity & Specification")}</div>
                  <div>{intl.get("Quantity")}</div>
                  <div>{intl.get("Product Cost")}</div>
                  <div>{intl.get("Cost 20% VAT IOSS")}</div>
                  <div>{intl.get("Order Amount")}</div>
                </div>
                {invoicesData.order_detail &&
                  invoicesData.order_detail.map((item, ind) => (
                    <div key={ind}>
                      <div style={{ textAlign: "left" }}>
                        <p className="invoices_title_table">{item.title}</p>
                        <p>{item.sku}</p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.quantity}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.product_cost}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.cost_vat}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {item.order_amount}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="invoices_total_price">
              <div>
                <span>{intl.get("Shipping")}:</span>${invoicesData.shipping_cost} USD 
              </div>
              <div>
                <span>{intl.get("Total")}:</span>${invoicesData.total_order_amount} USD 
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
);

export default OrderNoteModal;
